module.exports = __webpack_public_path__ + "img/w.40fd841c.jpg";